import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';

export const Wrapper = styled.div`
	margin-bottom: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 90%;

	${media.desktopSmall`
        margin-bottom: 120px;
	`};
`;

export const StepCircle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 5vw;
	height: 5vw;
	border-radius: 50%;

	svg {
		width: 2.5vw;
		height: 2.5vw;
	}
`;

export const StepText = styled.div`
	margin-top: 16px;
	position: absolute;
	left: -50%;
	top: 100%;
	width: 200%;
	display: block;
	font-family: ${theme.fonts.Arimo};
	line-height: 1.4;
	font-size: 18px;
	text-align: center;
`;

export const StepWrapper = styled.div<{ primary: boolean, secondary: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	flex-grow: 0;

	${StepCircle} {
		background-color: ${({ primary, secondary }) =>
			primary ? theme.colorsV2.mainPink : secondary ? theme.colorsV2.mainRed : theme.colorsV2.grey3};

		svg path {
			fill: ${({ primary, secondary }) => (primary || secondary ? theme.colors.white : theme.colorsV2.grey7)};
		}
	}

	${StepText} {
		font-weight: ${({ primary }) => primary && theme.fonts.weight.medium};
		color: ${({ primary, secondary }) => (primary || secondary ? theme.colorsV2.mainDark : theme.colorsV2.grey7)};
	}
`;

export const ArrowWrapper = styled.div<{ primary: boolean, secondary: boolean }>`
	display: flex;
	justify-content: center;
	flex-grow: 1;

	svg {
		path {
			fill: ${({ primary, secondary }) =>
				primary ? theme.colorsV2.mainPink : secondary ? theme.colorsV2.mainRed : theme.colorsV2.grey5};
		}
	}
`;
